const theme = require('./default');

module.exports = theme;
